import React from "react";
import { AirlineForm } from "./Forms/AirlineForm";
import { useCreateAirlineMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateAirline = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const { mutate: createAirline, isPending } = useCreateAirlineMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createAirline(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_AIRLINE")}/>
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <AirlineForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_AIRLINE")}
              </>
            ) : (
              t("CREATE_AIRLINE")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

